import * as React from "react";

import {
  getPlaidBankAccountName,
  Plaid,
} from "client/domain/FormBuilder/BankInformation";
import { SupportedBankConnectors } from "client/domain/FormBuilder/BankInformation/BankConnector";
import { Merchant } from "client/lib/apt-merchant";
import { BankFieldSetNames } from "client/lib/apt-merchant/src/fieldsets";

export const ConnectorButton: React.FC<{
  connector: SupportedBankConnectors | null;
  fieldSetName: BankFieldSetNames;
  merchant: Merchant;
  overrideSubmitHandler: (() => void) | undefined;
  plaidToken: string | undefined;
}> = ({
  connector,
  fieldSetName,
  merchant,
  overrideSubmitHandler,
  plaidToken,
}) => {
  const businessType = merchant.companyInformation.businessType.value;
  const legalBusinessName =
    merchant.companyInformation.legalBusinessName?.value;
  const firstOwnerFullName = `${merchant.owners[0].firstName.value} ${merchant.owners[0].lastName.value}`;
  const registeredCountry = merchant.companyInformation.registeredCountry.value;
  const salesChannel = merchant.lead.salesChannel.value;

  if (connector === "Plaid" && plaidToken) {
    return (
      <Plaid
        onSubmitSuccess={overrideSubmitHandler}
        plaidBankAccountName={getPlaidBankAccountName({
          businessType,
          legalBusinessName,
          firstOwnerFullName,
        })}
        salesChannel={salesChannel}
        registeredCountry={registeredCountry}
        token={plaidToken}
        fieldSetName={fieldSetName}
      />
    );
  }

  return null;
};
